// extracted by mini-css-extract-plugin
export var articleLink = "ArticleItem-module--article-link--37278";
export var articleWrap = "ArticleItem-module--article-wrap--8b2d4";
export var avatar = "ArticleItem-module--avatar--32128";
export var avatarImg = "ArticleItem-module--avatar-img--961fc";
export var content = "ArticleItem-module--content--129d7";
export var des = "ArticleItem-module--des--add95";
export var img = "ArticleItem-module--img--ea76d";
export var imgWrap = "ArticleItem-module--img-wrap--ce1cd";
export var subtitle = "ArticleItem-module--subtitle--fe5ec";
export var title = "ArticleItem-module--title--ad763";